<template>
    <div>
        <h1 style="display: none;">Theo dõi thời gian học tập</h1>
    </div>
</template>

<script>
import UserRequest from '@/restful/UserRequest';
export default {
    name: 'TrackingStudyLog',
    data() {
        return {
            user: {
                id: null,
                email: null,
                google_id: null,
                is_have_password: null,
                user_name: null,
                role: null,
                is_delete: null,
                is_block: null,
                name: null,
                phone: null,
                email_verified_at: null,
                created_at: null,
                updated_at: null,
                access_token: null,
                token_type: null,
                expires_in: null,
            },
            time: 120, // seconds
            intervalId: null, // Lưu ID của setInterval để quản lý
        };
    },
    mounted() {
        this.user = this.$getUserLogin();
        this.checkin();
        // Gọi updateTotalTime định kỳ sau mỗi khoảng thời gian 'time'
        this.intervalId = setInterval(() => {
            this.updateTotalTime();
        }, this.time * 1000); // Chuyển giây thành mili-giây
    },
    beforeUnmount() {
        // Dừng interval khi component bị hủy
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    methods: {
        checkin: async function () {
            try {
                await UserRequest.get('user/study-log/checkin');
            } catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }
        },
        updateTotalTime: async function () {
            try {
                const data_submit = {
                    time: this.time, // seconds
                };
                const { data } = await UserRequest.post('user/study-log/update-total-time', data_submit);
                console.log(data);
            } catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }
        },
    },
};
</script>